import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "link2",
  "use": "link2-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"link2\"><path d=\"M13.7 20a1.63 1.63 0 0 1-1.17-.49 7.8 7.8 0 0 1 0-11l6.14-6.14a7.81 7.81 0 0 1 11 11l-2.77 2.77a1.66 1.66 0 0 1-2.35-2.35L27.36 11a4.48 4.48 0 0 0 0-6.34 4.49 4.49 0 0 0-6.34 0l-6.14 6.14a4.48 4.48 0 0 0 0 6.34 1.66 1.66 0 0 1 0 2.35 1.63 1.63 0 0 1-1.18.51zM7.81 32a7.72 7.72 0 0 1-5.52-2.29 7.8 7.8 0 0 1 0-11l2.81-2.85a1.67 1.67 0 1 1 2.35 2.36L4.64 21a4.48 4.48 0 0 0 0 6.34 4.49 4.49 0 0 0 6.34 0l6.14-6.14a4.48 4.48 0 0 0 0-6.34 1.66 1.66 0 0 1 2.35-2.35 7.8 7.8 0 0 1 0 11l-6.14 6.14A7.75 7.75 0 0 1 7.81 32z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/link2.svg
// module id = PGQK
// module chunks = 1